import styled, { css } from 'styled-components'

const StyledPill = styled.a`
  border-radius: 42px;
  margin: 0 2.5px;
  padding: 10px 15px;
  text-align: center;
  text-decoration: none;
  transition: background-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  white-space: nowrap;

  /* Default style rules */
  ${(props) =>
    css`
      border: 1px solid ${props.theme.color_grey_dark};
      background-color: ${props.theme.color_white};
      color: ${props.theme.color_grey_darker};
      font-family: ${props.theme.font_family};
      font-weight: ${props.theme.font_weight_bold};
      font-size: ${props.theme.font_size_base};
    `}

  /* Hover style rules */
  ${(props) =>
    !props.active &&
    !props.disabled &&
    css`
      :hover {
        background-color: ${props.theme.color_grey_light};
        border: 1px solid ${props.theme.color_grey_dark};
        color: ${props.theme.color_grey_darker};
      }
    `}

  /* Active style rules */
  ${(props) =>
    props.active &&
    css`
      background-color: ${props.theme.color_tertiary_light};
      border: 1px solid ${props.theme.color_tertiary};
      color: ${props.theme.color_tertiary};

      :hover {
        border: 1px solid ${props.theme.color_tertiary_dark};
        color: ${props.theme.color_tertiary_dark};
      }
    `}

  /* Disabled style rules */
  ${(props) =>
    props.disabled &&
    css`
      background-color: ${props.theme.color_white};
      border: 1px solid ${props.theme.color_grey_mid};
      color: ${props.theme.color_grey_dark};
      cursor: not-allowed;
    `}
`

export default StyledPill
